import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import NewsSlider from "./components/news-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import ReassurancesSlider from './components/reassurances-slider';
import ScrollInView from "./components/scroll-in-view";
import DeviceManager from "./utils/device-manager";

import "./components/search-form";
import "./components/accordion-center";

$(function () {

	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		// const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Home slider component
		const $homesSliders = $(".homepage-slider");
		if ($homesSliders.length) {
			$homesSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// HOME News slider component
		const $newsSliders = $(".home .news-list");
		if ($newsSliders.length) {
			$newsSliders.each(function (index, el) {
				const newsSlider = new NewsSlider($(el));
			});
		}
		
		// SINGLE News slider component
		const $singlenewsSliders = $(".similar-news__container.news-list");
		if ($singlenewsSliders.length) {
			$singlenewsSliders.each(function (index, el) {
				const singlenewsSlider = new NewsSlider($(el));
			});
		}

		// Reassurances slider component
		const $reassurancesSliders = $(".reassurances-section-container");
		if ($reassurancesSliders.length) {
			$reassurancesSliders.each(function (index, el) {
				const reassurancesSlider = new ReassurancesSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}
	}

	bootstrapApp();
	instanciateComponents();

});
